<div class="login-section">
    <!--<div class="login-logo">
             <h2><img src="/assets/images/head_logo.png"></h2>
            </div>-->
    <div class="login-form-sec">
        <div class="form-section above-half">
            <h2>Forgot password</h2>
            <!--<form (ngSubmit)="doAdd(fm)" #fm="ngForm">-->
            <form [formGroup]="form" (ngSubmit)="doAction()">
                <div class="">
                    <div class="form-group">
                        <label>Email</label>
                        <input name="email" type="text" class="form-control" formControlName="email">
                        <span class="error_message" *ngIf="err.email">{{err.email}}</span>
                    </div>
                </div>
                <div class="form-group submit-group">
                    <button type="submit" class="btn btn-login">Login</button>
                </div>
                <a class="for_lft" routerLink="/login"><i class="fa fa-arrow-left" aria-hidden="true"></i><span>Back To Login</span></a>
                <!--                <p class="or-divider login_button">or</p>
                                <div class="form-group submit-group">
                                    <a class="btn btn-create" routerLink="/register-account">Create an account</a>
                                </div>-->
            </form>
        </div>
        <div class="login-cont-sec">
            <h2><img src="assets/images/head_logo.png"></h2>
            <p>
                24ieye is a leader in the media monitoring and brand listening industry, serving clients worldwide. Positioned at the forefront in the industry, we carved out a niche for itself as the leading provider of brand monitoring and risk protection services.
                <a href="https://www.24ieye.com/aboutus/" target="_blank"> Read more</a>
            </p>

            <p>
                We are here to provide you with more information, answer your queries, and offer effective brand monitoring solutions for your business needs. Looking to connect with us?  Want a more immediate response? Call our customer service representative. 
                <a href="https://www.24ieye.com/contact/" target="_blank"> Read more</a>
            </p>
        </div>
    </div>
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "rgb(199, 28, 109)" type = "square-loader" [fullScreen] = "true"></ngx-spinner>